import pusherManager from '../../assets/js/pusherManager'
import api from '../../assets/js/api.js'

const state = {
  authenticated: false,
  token: '',
  pusher: {
    listener: null,
    status: null,
    salesSessionChannelStatus: null
  },
  account: {
    session: {
      opentok: {
        id: '',
        token: '',
        dialog: false,
        key: '',
        shop: null,
        shopOwner: null,
        messages: [],
        sessionChannel: null,
        connected: false,
        started: false
      }
    }
  },
  redirect: {
    state: false,
    name: '',
    params: {}
  }
}

const getters = {
  auth_is_authenticated: state => {
    return state.authenticated
  },
  auth_get_is_verified: state => {
    return state.account && state.account.is_verified
  },
  auth_get_token: state => {
    return state.token
  },
  auth_talk_key: state => {
    return state.account.session ? state.account.session.opentok.key : ''
  },
  auth_stripe_key: state => {
    return state.account.session && state.account.session.stripe ? state.account.session.stripe.key : ''
  },
  auth_get_pusher_connected: state => {
    return state.pusher.status
  },
  auth_get_session_settings: state => {
    return state.account.session
  },
  auth_get_channels: state => {
    return state.account.channels
  },
  auth_get_redirect: state => {
    return state.redirect
  },
  auth_get_session_dialog: state => {
    return state.account.session ? state.account.session.opentok.dialog : false
  },
  auth_get_account: state => {
    return state.account
  }
}

const mutations = {
  AUTH_SET_AUTHENTICATED (state, auth) {
    state.token = auth
    if (state.token === '') {
      state.authenticated = false
      pusherManager.disconnect()
    }
  },
  AUTH_SET_ACCOUNT (state, account) {
    state.account = account
    state.authenticated = state.token !== ''
  },
  AUTH_INIT_PUSHER (state) {
    if (state.account.session) {
      pusherManager.init(state.token)
    }
  },
  AUTH_SET_PUSHER_LISTENER (state) {
    if (state.account.session) {
      // pusherManager.initShopLineChannel(state.account.channels.shopline) // this info is not set here, should it???, only makes sense when you go into a shop
      pusherManager.initUserChannel(state.account.channels.user)
      pusherManager.initGeneralChannel(state.account.channels.general)
    }
  },
  AUTH_SET_PUSHER_CONNECTED_STATUS (state, status) {
    state.pusher.status = status
  },
  AUTH_SET_REDIRECT (state, payload) {
    state.redirect.state = payload.state
    state.redirect.name = payload.name
    state.redirect.params = payload.params
  }
}

const actions = {
  getAuthAccount ({ commit, dispatch, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('getAuthAccount')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'getAuthAccount')
      api.getAuthAccount().then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getAuthAccount')
          commit('AUTH_SET_ACCOUNT', response.data)
          dispatch('getCarts', {user: response.data.uid})
          if (payload && payload.cb) {
            payload.cb()
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'getAuthAccount')
          console.log(error)
          if (payload && payload.errorCb) {
            payload.errorCb()
          }
        }
      )
    }
  },
  verifyAccount ({commit, rootGetters}, payload) {
    if (!rootGetters.global_is_busy_method('verifyAccount')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'verifyAccount')
      api.verifyAccount(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'verifyAccount')
          console.log(response.data)
          commit('AUTH_SET_ACCOUNT', response.data)
          if (payload.cb) {
            payload.cb(response.data)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'verifyAccount')
          console.log(error)
          if (payload.errorCb) {
            payload.errorCb(error)
          }
        }
      )
    }
  },
  logout ({ commit, rootGetters }) {
    if (!rootGetters.global_is_busy_method('logout')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'logout')
      api.logOut().then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'logout')
          commit('AUTH_SET_AUTHENTICATED', '')
          window.location.reload(true)
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'logout')
          console.log(error)
          commit('AUTH_SET_AUTHENTICATED', '')
          window.location.reload(true)
        }
      )
    }
  },
  sendChatMessage ({ commit, rootGetters }, payload) {
    if (!rootGetters.global_is_busy_method('sendChatMessage')) {
      commit('GLOBAL_SET_BUSY_METHOD', 'sendChatMessage')
      api.sendChatMessage(payload).then(
        response => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'sendChatMessage')
          console.log(response.data)
          if (payload.cb) {
            payload.cb(response)
          }
        },
        error => {
          commit('GLOBAL_UNSET_BUSY_METHOD', 'sendChatMessage')
          console.log(error)
          if (payload.cb) {
            payload.errorCb(error)
          }
        }
      )
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js